import { render, staticRenderFns } from "./switch-btn.vue?vue&type=template&id=41e993e8&scoped=true&"
import script from "./switch-btn.vue?vue&type=script&lang=js&"
export * from "./switch-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e993e8",
  null
  
)

export default component.exports